import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import techRadarPlugin from '@backstage-community/plugin-tech-radar/alpha';
import { discoveryApiRef, fetchApiRef } from '@backstage/frontend-plugin-api';
import { TechRadarClient } from '../lib';

export const techRadarPluginOverrides: typeof techRadarPlugin = techRadarPlugin.withOverrides({
  extensions: [
    techRadarPlugin.getExtension('api:tech-radar').override({
      params: defineParams =>
        defineParams({
          api: techRadarApiRef,
          deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
          factory: ({ discoveryApi, fetchApi }) => new TechRadarClient({ discoveryApi, fetchApi }),
        }),
    }),
    techRadarPlugin.getExtension('page:tech-radar').override({
      params: {
        path: '/tech-radar',
        routeRef: techRadarPlugin.routes.root,
        loader: () => import('../components/tech-radar/RadarPage').then(m => <m.RadarPage />),
      },
    }),
  ],
});
